import { memo, useEffect } from 'react';
import { Icon } from '@uniquegood/realworld-studio-design';

import { ContextMenuStyle, ContextMenuItemStyle, ContextMenuItemDestructive } from '../styles';

interface FlowContextMenuProps {
  x: number;
  y: number;
  onAddQuest: () => void;
  onDeleteMission: () => void;
  onClose: () => void;
}

function FlowContextMenu({ x, y, onAddQuest, onDeleteMission, onClose }: FlowContextMenuProps) {
  useEffect(() => {
    const handler = () => onClose();
    document.addEventListener('click', handler);
    return () => document.removeEventListener('click', handler);
  }, [onClose]);

  return (
    <div css={ContextMenuStyle} style={{ top: y, left: x }}>
      <button type="button" css={ContextMenuItemStyle} onClick={onAddQuest}>
        <Icon icon="plus_solid" size="14px" />
        퀘스트 추가
      </button>
      <button
        type="button"
        css={[ContextMenuItemStyle, ContextMenuItemDestructive]}
        onClick={onDeleteMission}
      >
        <Icon icon="trash_alt_solid" size="14px" />
        미션 삭제
      </button>
    </div>
  );
}

export default memo(FlowContextMenu);
